module.exports = __webpack_public_path__ + "img/logo-icon-app.8184ad8d.png";